import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMarker2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="marker-2, highlight"><path d="M20 12.5L17 9.5L13.5 8.5L7.5 14.5L8.5 18L11.5 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.5 13.5L5 11L6 2.5L12.5 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMarker2;
